import { isStatus } from '@/utils'
import { INSIGHTS_STATUSES } from '../constants'
import type { Insights, InsightsStatusKey } from '../stores'

export const isInsightsNotStarted = (insights: Insights) =>
  isInsightsStatus(insights, 'notStarted')

export const isInsightsProcessing = (insights: Insights) =>
  isInsightsStatus(insights, 'processing', 'enqueued')

export const hasInsightsSucceeded = (insights: Insights) =>
  isInsightsStatus(insights, 'succeeded')

export const hasInsightsResult = (insights: Insights) =>
  hasInsightsSucceeded(insights) || insights.hasResult

export const hasInsightsFinished = (insights: Insights) =>
  isInsightsStatus(insights, 'failed', 'succeeded')

export const hasInsightsFailed = (insights: Insights) =>
  isInsightsStatus(insights, 'failed')

export const isInsightsStatus = (
  insights: Insights,
  ...expectations: InsightsStatusKey[]
) => isStatus(INSIGHTS_STATUSES, insights, 'status', ...expectations)
